import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function PlanningDraftRoutesAPI(): BringozApi {
  return {
    base: `/planning/projects/{projectId}/drafts/{draftId}/routes`,
    infiniteScroll: {
      address: `/planning/projects/{projectId}/drafts/{draftId}/routes`,
      cmd: 'GET'
    }
  }
}


angular
  .module('bringoz.admin.planning')
  .service('PlanningDraftRoutesAPI', PlanningDraftRoutesAPI);
